/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import Charts from 'react-apexcharts'
import { useQuery } from '@apollo/client'
import { useStateWithCallback } from '../../utils/hooks/useStateWithCallback'
import { GET_GRAPH_ANALYTICS } from '../../graphql/query'
import { IBotAnalyticsFilterInput } from '../../utils/interfaces/IBotAnalyticsFilterInput'

type Props = {
  className: string
  graphAnalyticsFilterInput: IBotAnalyticsFilterInput
  setIsLoading: any
}

interface ApexChartsvalue {
  options: {
    chart: {
      id: string
    }
    xaxis: {
      categories: string[]
    }
  }
  series: [
    {
      name: string
      data: number[]
    }
  ]
}

const SixMonthBotRecord: React.FC<Props> = ({
  className,
  graphAnalyticsFilterInput,
  setIsLoading
}) => {
  const defaultValues: ApexChartsvalue = {
    options: {
      chart: {
        id: 'basic-bar'
      },
      xaxis: {
        categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul']
      }
    },
    series: [
      {
        name: 'Bot Conversation',
        data: [15, 25, 15, 40, 20, 10]
      }
    ]
  }
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]

  const [state, setState] = useStateWithCallback<ApexChartsvalue>(defaultValues)
  const [graphAnalyticsSixMonthFilterInput] = useStateWithCallback<IBotAnalyticsFilterInput>({
    applicationIds: graphAnalyticsFilterInput.applicationIds,
    startDate: new Date(new Date().setMonth(new Date().getMonth() - 5)).toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0],
    groupBy: 'month'
  })
  const [totalBotConversation, setTotalBotConversation] = useState(0)

  const {
    loading,
    error,
    data,
    refetch: refetchSixMonthGraphAnalytics
  } = useQuery(GET_GRAPH_ANALYTICS, {
    variables: {
      input: {
        ...graphAnalyticsSixMonthFilterInput
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Dashboard'
      }
    }
  })

  useEffect(() => {
    refetchSixMonthGraphAnalytics({
      input: {
        ...graphAnalyticsSixMonthFilterInput,
        applicationIds: graphAnalyticsFilterInput.applicationIds
      },
      context: {
        headers: {
          'access-control-allow-methods': 'Dashboard'
        }
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [graphAnalyticsFilterInput])

  useEffect(() => {
    if (data) {
      const { graphX, graphY, totalConversations } = processGraphData(data)
      updateGraphState(graphX, graphY)
      setTotalBotConversation(totalConversations)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const processGraphData = (dataProcess: any) => {
    const graphX: string[] = []
    const graphY: number[] = []
    const value = dataProcess.graphAnalytics[0] || []
    const length = value.graphData ? Object.keys(value.graphData).length : 0

    for (let i = 0; i < length; i++) {
      if (
        value.graphData[i] &&
        value.graphData[i].month &&
        value.graphData[i].totalBotConversations
      ) {
        let splitDate = value.graphData[i].month.split('-')
        graphX.push(`${months[Number(splitDate[1].replace(/^0+/, '') - 1)]}-${splitDate[0]}`)
        graphY.push(value.graphData[i].totalBotConversations)
      }
    }
    const totalConversations = graphY.reduce((sum, a) => sum + a, 0)
    return { graphX, graphY, totalConversations }
  }

  const updateGraphState = (graphX: any, graphY: any) => {
    setState((prevState) => ({
      ...prevState,
      options: {
        ...prevState.options,
        xaxis: {
          categories: graphX
        }
      },
      series: [
        {
          name: prevState.series[0].name,
          data: graphY
        }
      ]
    }))
  }

  if (loading && error) {
    setIsLoading(true)
  }
  return (
    <div className={`card ${className}`}>
      <div className='card-body d-flex flex-column p-0'>
        <div className='flex-grow-1 card-p pb-0'>
          <div className='d-flex flex-stack flex-wrap'>
            <div className='me-2'>
              <a href='#' className='text-dark text-hover-primary fw-bolder fs-4 fs-md-6'>
                Conversations Last six Months
              </a>
            </div>

            <div className={`fw-bolder fs-4 fs-md-6 text-primary`}>
              <span className={`fw-bolder fs-4 fs-md-6 text-black`}>Total Bot Conversations</span>{' '}
              {totalBotConversation}
            </div>
          </div>
        </div>

        <Charts
          options={state.options}
          series={state.series}
          type='area'
          height='275px'
          style={{ zIndex: '0' }}
        />
      </div>
    </div>
  )
}

export default SixMonthBotRecord
